import { atsApiQuery } from '..';

export const atsApplicationApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllJobs: builder.query({
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs`,
            method: 'get',
            params,
          };
        },
      }),
      getAllJobsList: builder.query({
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs/list`,
            method: 'get',
            params,
          };
        },
      }),
      // Hiring-team endpoints moved to React Query — see
      // `src/api/useGetHiringTeamOfJob`.
    };
  },
  overrideExisting: true,
});

export const { useGetAllJobsQuery, useGetAllJobsListQuery } = atsApplicationApi;
